import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';
import { IdleSessionService } from '@app/core/auth/idle-session.service';
//import { provideHttpClient, withInterceptors } from '@angular/common/http';
//import { authInterceptor } from '@app/core/auth/auth.interceptor';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        // [AG] Commented out to fix the issue with multiple calls to the backend on app init
        //provideHttpClient(withInterceptors([authInterceptor])),
        provideEnvironmentInitializer(() => {
            inject(AuthService);
            inject(IdleSessionService).startWatching();
        }),
    ];
};
